/* eslint-disable import/prefer-default-export */
const getGlobalState = (state, key) => (Array.isArray(state.marketMargins[key]) ? state.marketMargins[key].slice(0) : state.marketMargins[key]);

export const selectorMarketMargins = (state) => getGlobalState(state, 'marketMargins');
export const selectorTennisMarketMargins = (state) => getGlobalState(state, 'tennisMarketMargins');
